import Button from './Button'

/**
 * Closing call to action. Every page ends with exactly one, pointing to /contact.
 */
export default function CtaBand({ title, label = 'Get in touch', to = '/contact' }) {
  return (
    <section className="border-t-2 border-ink bg-white">
      <div className="mx-auto flex max-w-[1180px] flex-wrap items-center justify-between gap-6 px-4 py-10 sm:px-6">
        <h2 className="max-w-xl font-serif text-2xl font-bold text-ink">{title}</h2>
        <Button to={to}>{label}</Button>
      </div>
    </section>
  )
}
